// Navigation des Moduls `verguetung` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul verguetung.
import { ChartBar, CurrencyCircleDollar, Ruler } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'verguetung',
  title: 'Compensation & pay review',
  nav: {
    people: [
      {
        key: 'verguetung.tab',
        label: 'Compensation',
        icon: CurrencyCircleDollar,
        path: '/people/me/compensation',
        roles: ['ALL'],
        order: 20,
        area: 'tabs:rewards',
      },
    ],
    admin: [
      {
        key: 'verguetung.payreview',
        label: 'Pay review',
        icon: CurrencyCircleDollar,
        path: '/rewards/pay-review',
        // D12 `comp.payreview.read` (SPEC §1.5); ADM ohne diese Rollen hat keinen Zugriff.
        roles: ['PERF', 'COMP', 'HR', 'CL', 'CEO'],
        readOnly: ['HR'],
        order: 330,
        area: 'Rewards',
      },
      {
        key: 'verguetung.benchmarks',
        label: 'Benchmarks',
        icon: ChartBar,
        path: '/rewards/benchmarks',
        // D12 `comp.benchmarks.read`; schreiben nur PERF und COMP.
        roles: ['PERF', 'COMP', 'HR', 'CL', 'CEO'],
        readOnly: ['HR', 'CL', 'CEO'],
        order: 340,
        area: 'Rewards',
      },
      {
        key: 'verguetung.bands',
        label: 'Salary bands',
        icon: Ruler,
        path: '/rewards/bands',
        roles: ['PERF', 'COMP', 'HR', 'CL', 'CEO'],
        order: 350,
        area: 'Rewards',
        readOnly: ['PERF', 'HR', 'CL', 'CEO'],
      },
    ],
  },
});
